
import { get, put, post, sendDelete } from '../helpers/api.helper';

export async function List(year = undefined, month = undefined) {
    try {
        if (year !== undefined && month !== undefined) {
            return await get(`finalizavenda/user?year=${year}&month=${month}`);
        }

        return await get('finalizavenda/user');
    } catch (error) {
        console.error('Erro ao criar cadastro');
    }
}

export async function ListPaginate(pageSize, page, cod_revendedor, cod_cliente) {
    try {
        let query =  '';

        if(cod_revendedor)
            query =  `&cod_revendedor=${cod_revendedor}`;

        if(cod_cliente)
            query +=  `&cod_cliente=${cod_cliente}`;

        return await get(`finalizavenda/user/paginated?page=${page}&pageSize=${pageSize}${query}`);
    } catch (error) {
        console.error('Erro ao criar cadastro');
    }
}


export async function ListByCustomer(customerId, year = undefined, month = undefined) {
    try {
        if (year !== undefined && month !== undefined) {
            return await get(`finalizavenda/user/customer/${customerId}?year=${year}&month=${month}`);
        }

        return await get(`finalizavenda/user/customer/${customerId}`);
    } catch (error) {
        console.error('Erro ao buscar dados');
    }
}

export async function ListItensByCustomer(customerId, year = undefined, month = undefined) {
    try {
        return await get(`finalizavenda/cliente/${customerId}/vendas/itens?year=${year}&month=${month}`);
    } catch (error) {
        console.error('Erro ao criar cadastro');
    }
}

export async function ListItensDateInterval(customerId, startDate, endDate) {
    try {
        return await get(`finalizavenda/filterdates?startDate=${startDate}&endDate=${endDate}&customerId=${customerId}`);
    } catch (error) {
        console.error('Erro ao criar cadastro');
    }
}

export async function FinalizaItens(itens, startdate, enddate) {
    try {
        return await post(`finalizavenda/gerafechamento?startdate=${startdate}&endDate=${enddate}`, itens);
    } catch (error) {
        console.error('Erro ao criar cadastro');
    }
}

export async function GetFechamento() {
    try {
        return await get(`finalizavenda/getFechamentos`);
    } catch (error) {
        console.error('Erro ao criar cadastro');
    }
}

export async function GetById(id) {
    try {
        return await get(`FinalizaVenda/venda/${id}/itens`);
    } catch (error) {
        console.error('Erro ao criar cadastro');
    }
}

export async function GetSellerById(id) {
    try {
        return await get(`FinalizaVenda/${id}`);
    } catch (error) {
        console.error('Erro ao criar cadastro');
    }
}


export async function GetTopProduct() {
    try {
        return await get(`FinalizaVenda/venda/topItens`);
    } catch (error) {
        console.error('Erro ao criar cadastro');
    }
}

export async function GetTopProductsList(quantity) {
    try {
        return await get(`/Vendas/top-products?quantity=${quantity}`);
    } catch (error) {
        console.error('Erro ao criar cadastro');
    }
}

export async function CheckSincronizedSeller(id) {
    try {
        let sincronizedSeller = { id: id };
        return await put(`FinalizaVenda/venda/sincronized`, sincronizedSeller);
    } catch (error) {
        console.error('Erro ao criar cadastro');
    }
}

export async function deleteItem(id) {
    try {
        return await sendDelete(`finalizavenda/${id}`);
    } catch (error) {
        console.error('Erro ao processar requisição');
    }
}
